import { Component, Input } from '@angular/core';
import { UnitDescriptionSecureWindowService } from 'src/app/shared/services/unit-description-secure-window.service';
import { AMSubmittalInfoHeader } from '../../model/am-submittal-info-header.model';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { MultiLineCustomTooltipDirective } from '../../../../../shared/directives/multi-line-custom-tooltip.directive';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'nova-am-submittal-send-to-client-info-card',
    templateUrl: './send-to-client-info-card.component.html',
    styleUrls: ['./send-to-client-info-card.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass, RouterLink, MatIconModule, MultiLineCustomTooltipDirective]
})
export class SendToClientInfoCardComponent {
    @Input()
    model: AMSubmittalInfoHeader;

    @Input()
    labelFlex = '20';

    @Input()
    dataFlex = '80';

    @Input()
    isClinical: boolean;

    @Input()
    infoBubbleNote: string;

    readonly featureFlag = FeatureFlag;

    constructor(private readonly unitDescriptionSecureWindow: UnitDescriptionSecureWindowService) {}

    openUnitFormUrl($event: MouseEvent, url: string) {
        $event.preventDefault();
        if (url) {
            this.unitDescriptionSecureWindow.open(url, '_blank', true);
        }
    }
}
